module.exports = __webpack_public_path__ + "static/media/ceo_zh.587b35dc.png";